import { RouteRecordRaw } from 'vue-router';
import pageSeventeen from '@/router/routerListOne/routerList/pageSeventeen';
import pageTwentyEight from '@/router/routerListOne/routerList/pageTwentyEight';
// import pageThirtyFour from '@/router/routerListOne/routerList/pageThirtyFour';
// import pageThirtyFive from '@/router/routerListOne/routerList/pageThirtyFive';
import pageFiftyFour from '@/router/routerListOne/routerList/pageFiftyFour';
import pageFiftyFive from '@/router/routerListOne/routerList/pageFiftyFive';
import pageSeventyTwo from '@/router/routerListOne/routerList/pageSeventyTwo';
import pageSeventyNine from '@/router/routerListOne/routerList/pageSeventyNine';
import pageEightyFour from '@/router/routerListOne/routerList/pageEightyFour';
import pageEightyEight from '@/router/routerListOne/routerList/pageEightyEight';
import pageNinetyThree from '@/router/routerListOne/routerList/pageNinetyThree';
import pageNinetyFour from '@/router/routerListOne/routerList/pageNinetyFour';
import pageNinetySix from '@/router/routerListOne/routerList/pageNinetySix';

export const pageRouterOne: Array<RouteRecordRaw> = [
  ...pageSeventeen,
  ...pageTwentyEight,
  // ...pageThirtyFour,
  // ...pageThirtyFive,
  ...pageFiftyFour,
  ...pageFiftyFive,
  ...pageSeventyTwo,
  ...pageSeventyNine,
  ...pageEightyFour,
  ...pageEightyEight,
  ...pageNinetyThree,
  ...pageNinetyFour,
  ...pageNinetySix,
];
